export default "__VITE_ASSET__BfGvs8HH__"